var map = {
	"./20250505_61558pmByGPSMapCamera.jpg": 66701,
	"./20250505_63025pmByGPSMapCamera.jpg": 72666,
	"./IMG-20250505-WA0013.jpg": 52855,
	"./IMG-20250505-WA0020.jpg": 66105,
	"./IMG-20250505-WA0023.jpg": 85838,
	"./TOT Competency Syllabus Workshop.pdf": 8507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24731;